export function enumValues(myEnum: any): string[] {
  return Object.keys(myEnum)
    .map(key => myEnum[key])
    .filter(value => typeof value === 'string') as string[];
}
